var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "navbar" },
    [
      _c(
        "div",
        { class: { "has-logo": _vm.showLogo } },
        [
          _vm.showLogo
            ? _c("logo", { attrs: { collapse: _vm.isCollapse } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "apps" }, [_c("apps")], 1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "right-menu" },
        [
          _c(
            "div",
            { staticClass: "message-bell" },
            [
              _c(
                "el-dropdown",
                {
                  attrs: { trigger: "click", placement: "bottom-start" },
                  on: { command: _vm.handleMessageCommand },
                },
                [
                  _c(
                    "div",
                    { staticClass: "message-bell-icon" },
                    [
                      _c(
                        "el-badge",
                        {
                          staticClass: "item",
                          attrs: {
                            value: _vm.totalUnreadMessages,
                            hidden: _vm.totalUnreadMessages === 0,
                          },
                        },
                        [_c("i", { staticClass: "el-icon-bell" })]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    {
                      staticClass: "message-dropdown",
                      attrs: { slot: "dropdown" },
                      slot: "dropdown",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "message-list-container" },
                        [
                          _vm.recentMessages.length === 0
                            ? _c(
                                "el-dropdown-item",
                                { attrs: { disabled: "" } },
                                [
                                  _vm._v(
                                    "\n                暂无新消息\n              "
                                  ),
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm._l(_vm.recentMessages, function (message) {
                            return _c(
                              "el-dropdown-item",
                              {
                                key: message.messageKey,
                                class: { unread: message.status === 0 },
                                attrs: {
                                  divided: "",
                                  size: "mini",
                                  command: message,
                                },
                              },
                              [
                                _c("div", { staticClass: "message-item" }, [
                                  _c(
                                    "div",
                                    { staticClass: "message-item-header" },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "message-type" },
                                        [
                                          message.type == "1"
                                            ? [
                                                _c("Icon", {
                                                  attrs: {
                                                    icon: "material-symbols:finance-chip-outline",
                                                  },
                                                }),
                                              ]
                                            : message.type == "2"
                                            ? [
                                                _c("Icon", {
                                                  attrs: {
                                                    icon: "material-symbols:warehouse-outline",
                                                  },
                                                }),
                                              ]
                                            : message.type == "4"
                                            ? [
                                                _c("Icon", {
                                                  attrs: {
                                                    icon: "tdesign:system-application",
                                                  },
                                                }),
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("strong", [
                                            _vm._v(_vm._s(message.typeName)),
                                          ]),
                                        ],
                                        2
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "message-date" },
                                        [_vm._v(_vm._s(message.messageDate))]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "message-title" }, [
                                    _vm._v(_vm._s(message.messageTitle)),
                                  ]),
                                ]),
                              ]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.device !== "mobile"
            ? [
                _c("error-log", {
                  staticClass: "errLog-container right-menu-item hover-effect",
                }),
                _vm._v(" "),
                _c("screenfull", {
                  staticClass: "right-menu-item hover-effect",
                  attrs: { id: "screenfull" },
                }),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-dropdown",
            {
              staticClass: "avatar-container right-menu-item hover-effect",
              attrs: { trigger: "click" },
            },
            [
              _c("div", { staticClass: "avatar-wrapper" }, [
                _c("p", [
                  _vm.warehouseName
                    ? _c("span", [_vm._v(_vm._s(_vm.warehouseName))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("p", [
                  _vm.userName
                    ? _c("span", [_vm._v(_vm._s(_vm.userName))])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.avatarImg !== "null"
                  ? _c("img", {
                      staticClass: "user-avatar",
                      attrs: { src: _vm._f("picFilter")(_vm.avatarImg) },
                    })
                  : _c("img", {
                      staticClass: "user-avatar",
                      attrs: {
                        src: require("../../assets/logo/avatar-default.png"),
                      },
                    }),
                _vm._v(" "),
                _c("i", { staticClass: "el-icon-caret-bottom" }),
              ]),
              _vm._v(" "),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  _c(
                    "el-dropdown-item",
                    {
                      attrs: { divided: "" },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.logout($event)
                        },
                      },
                    },
                    [
                      _c("span", { staticStyle: { display: "block" } }, [
                        _vm._v("退出账号"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.messageDialogVisible,
            title: _vm.selectedMessage
              ? _vm.selectedMessage.messageTitle
              : "消息详情",
            width: "30%",
            "append-to-body": true,
            "custom-class": "message-detail-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.messageDialogVisible = $event
            },
          },
        },
        [
          _vm.selectedMessage
            ? _c("div", { staticClass: "message-detail" }, [
                _c("div", { staticClass: "message-info" }, [
                  _c(
                    "span",
                    { staticClass: "message-type" },
                    [
                      _vm.selectedMessage.type == "1"
                        ? [
                            _c("Icon", {
                              attrs: {
                                icon: "material-symbols:finance-chip-outline",
                              },
                            }),
                          ]
                        : _vm.selectedMessage.type == "2"
                        ? [
                            _c("Icon", {
                              attrs: {
                                icon: "material-symbols:warehouse-outline",
                              },
                            }),
                          ]
                        : _vm.selectedMessage.type == "4"
                        ? [
                            _c("Icon", {
                              attrs: { icon: "tdesign:system-application" },
                            }),
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c("strong", { staticClass: "message-header" }, [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.selectedMessage.typeName) +
                            "\n              "
                        ),
                        _c("span", { staticClass: "spacer" }),
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.selectedMessage.messageDate) +
                            "\n            "
                        ),
                      ]),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                _c("pre", {
                  staticClass: "message-content",
                  domProps: { innerHTML: _vm._s(_vm.formattedMessageContent) },
                }),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }